import { Check } from 'lucide-react';
import { CodeSmall } from '@/components/shared/typography/CodeText';
import { getFilePathDisplayLabel } from '@kirin/api-client/contracts';
import { getFileName } from '@/lib/utils';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';
import { PlatformBadge } from '@/components/shared/platform/PlatformBadge';

interface SeverityFilterOptionProps {
  severity: string;
  isSelected: boolean;
}

export function SeverityFilterOption({
  severity,
  isSelected,
}: SeverityFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <SeverityBadge riskLevel={severity} showIcon />
    </div>
  );
}

interface FilePathFilterOptionProps {
  filePath: string;
  isSelected: boolean;
}

interface ClientTypeFilterOptionProps {
  clientType: string;
  isSelected: boolean;
}

export function ClientTypeFilterOption({
  clientType,
  isSelected,
}: ClientTypeFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <PlatformBadge platform={clientType} showTooltip={false} />
    </div>
  );
}

export function FilePathFilterOption({
  filePath,
  isSelected,
}: FilePathFilterOptionProps) {
  const displayLabel = getFilePathDisplayLabel(filePath);
  const fileName = getFileName(filePath);

  return (
    <div className="flex w-full min-w-0 items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <CodeSmall background className="block truncate">
          {fileName}
        </CodeSmall>
        <span className="block truncate text-xs text-muted-foreground">
          {displayLabel}
        </span>
      </div>
    </div>
  );
}
